import React, { useState } from 'react'
import { MessageChatCircle, MessageSmileCircle } from '../../Icons';

const ConsumerContact = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    message: ""
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData?.firstName) {
      alert("Please enter your First Name")
      return true
    } else if (!formData?.lastName) {
      alert("Please enter your Last Name")
      return true
    } else if (!formData?.email) {
      alert("Please enter your email")
      return true
    } else if (!formData?.message) {
      alert("Please enter your message")
      return true
    } else if (!formData?.phoneNumber) {
      alert("Please enter your phone number")
      return true
    }
    const apiUrl = 'https://v1.nocodeapi.com/ubaidullahomer/google_sheets/xcXYHqfRMBQmgYMm?tabId=Sheet1'; // Your API endpoint

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify([[
          formData.firstName,
          formData.lastName,
          formData.email,
          formData.phoneNumber,
          formData.message,
          "Consumer"
        ]])
      });

      if (response.ok) {
        console.log('Form data submitted successfully');
        // setFormData({
        //   firstName: "",
        //   lastName: "",
        //   email: "",
        //   phoneNumber: "",
        //   message: ""
        // })
        alert('Form data submitted successfully');
      } else {
        console.error('Error submitting form data');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };


  return (
    <>
      {/* Banner Section */}
      <div className="flex flex-col gap-[24px]  py-[64px] w-full max-w-[1600px]">
        <div className="flex flex-col">
          <span className='text-[#F02E49] font-[600]'>Get in Touch</span>
          <h2 className='text-[#101828] text-[48px] max-lg:text-[40px] max-md:text-[36px] max-sm:text-[32px] font-[600]'>
            We’d love to hear from you
          </h2>
        </div>
        <p className='text-[#475467] '>Our friendly team is always here to chat.</p>
      </div>

      {/* ConsumerContact Cards */}
      <div className="grid grid-cols-2 gap-[24px]  py-[64px] w-full max-w-[1600px] max-sm:grid-cols-1">
        <div className="bg-[#F9FAFB] flex flex-col gap-[64px] p-[24px] rounded-[10px] items-start">
          <div className="flex items-center justify-center rounded-xl p-[12px] bg-[#F02E49] w-fit">
            <MessageSmileCircle className="w-[24px] h-[24px]" />
          </div>
          <div className="flex flex-col gap-[20px]">
            <div className="flex flex-col gap-[8px]">
              <span className="text-[#101828] text-[20px] font-[600]">ConsumerContact Support</span>
              <span className="text-[#475467] text-[16px] font-[400]">Speak to our friendly team.</span>
            </div>
            <a target='_blank' href='mailto:Support@CertifiedDJ.co.uk' rel="noreferrer" className="text-[#5556C3] font-[600]"> Support@CertifiedDJ.co.uk</a>
          </div>
        </div>
        <div className="bg-[#F9FAFB] flex flex-col gap-[64px] p-[24px] rounded-[10px] items-start">
          <div className="flex items-center justify-center rounded-xl p-[12px] bg-[#F02E49] w-fit">
            <MessageChatCircle iconColor={'#fff'} className="w-[24px] h-[24px]" />
          </div>
          <div className="flex flex-col gap-[20px]">
            <div className="flex flex-col gap-[8px]">
              <span className="text-[#101828] text-[20px] font-[600]">Chat Support</span>
              <span className="text-[#475467] text-[16px] font-[400]">We are here to help.</span>
            </div>
            <a target='_blank' href='mailto:Info@CertifiedDJ.co.uk' rel="noreferrer" className="text-[#5556C3] font-[600]">Info@CertifiedDJ.co.uk</a>
          </div>
        </div>
      </div>

      {/* ConsumerContact Form Section */}
      <div className="flex flex-col items-center gap-[64px] px-[7.7vw] py-[64px] w-full max-w-[1600px]">
        <div className="flex flex-col gap-[0px] items-center">
          <span className='text-[#F02E49] font-[600]'>Add your info</span>
          <h1 className='text-[#101828] text-[32px] max-sm:text-[24px] font-[600]'>Join Waiting List</h1>
          <p className='text-[#475467] mt-[12px]'>We’d love to hear from you. Please fill out this form.</p>
        </div>
        <form onSubmit={handleSubmit} className="grid grid-cols-2 gap-[32px] max-sm:gap-[16px] max-sm:flex max-sm:flex-col max-sm:w-full">
          <div className={` flex flex-col gap-[6px] w-full`}>
            <label htmlFor="" className='text-[14px] text-[#344054] font-[500]'>
              First name
            </label>
            <input type={'text'} placeholder={'First name'} value={formData.firstName} onChange={handleChange} name='firstName' style={{ border: '1px solid #D0D5DD' }} className=' w-full placeholder:text-[#667085] text-[#667085] p-[10px] px-[14px] outline-none rounded-[8px]' />
          </div>
          <div className={` flex flex-col gap-[6px] w-full`}>

            <label htmlFor="" className='text-[14px] text-[#344054] font-[500]'>
              Last name
            </label>

            <input type={'text'} placeholder={'Last name'} value={formData.lastName} onChange={handleChange} name='lastName' style={{ border: '1px solid #D0D5DD' }} className=' w-full placeholder:text-[#667085] text-[#667085] p-[10px] px-[14px] outline-none rounded-[8px]' />

          </div>
          <div className={` flex flex-col gap-[6px] w-full col-span-2`}>

            <label htmlFor="" className='text-[14px] text-[#344054] font-[500]'>
              Email
            </label>

            <input type={'email'} placeholder={'you@company.com'} value={formData.email} onChange={handleChange} name='email' style={{ border: '1px solid #D0D5DD' }} className=' w-full placeholder:text-[#667085] text-[#667085] p-[10px] px-[14px] outline-none rounded-[8px]' />

          </div>
          <div className={` flex flex-col gap-[6px] w-full col-span-2`}>

            <label htmlFor="" className='text-[14px] text-[#344054] font-[500]'>
              Phone number
            </label>

            <input type={'number'} placeholder={'+44 46 3442 12987'} value={formData.phoneNumber} onChange={handleChange} name='phoneNumber' style={{ border: '1px solid #D0D5DD' }} className=' w-full placeholder:text-[#667085] text-[#667085] p-[10px] px-[14px] outline-none rounded-[8px]' />

          </div>
          <div className="flex flex-col gap-[6px] w-full col-span-2">
            <label htmlFor="" className='text-[14px] text-[#344054] font-[500]'>Message</label>
            <textarea
              style={{ border: '1px solid #D0D5DD' }}
              cols="30"
              rows="7"
              value={formData.message} onChange={handleChange} name='message'
              placeholder='Your message here...'
              className='w-full placeholder:text-[#667085] text-[#667085] p-[10px] px-[14px] outline-none rounded-[8px] resize-none'
            ></textarea>
          </div>
          <div className="flex items-center gap-[12px] col-span-2">
            <input id='privacyPolicy' type="checkbox" className='w-[20px] h-[20px]' />
            <label htmlFor='privacyPolicy' className='text-[#475467]'>You agree to our friendly privacy policy.</label>
          </div>
          <button className='flex items-center gap-[24px] px-[24px] py-[12px] bg-[#F02E49] text-[#fff] rounded-[8px] w-full col-span-2 text-center justify-center mt-[16px]'>
            Save
          </button>
        </form>
      </div>
    </>
  )
}

export default ConsumerContact;